'use strict'

import Axios from 'axios';
import configuration from "../../configuration";

const url = configuration.apiHost + "productCategorys";

export default class ProductCategoryService {

  static validade(productCategory) {
    let errors = []
    if (!productCategory.type) errors.push('tipo - categoria')
    if (!productCategory.description) errors.push('descrição')

    if (errors.length > 0) return errors
    else return null
  }

  static async getAll() {
    try {
      let productCategorys = await Axios.get(url);
      return productCategorys.data;
    } catch (error) {
      throw error.response.data;
    }
  } // getAll()

  static async save(productCategory) {
    try {
      let productCategorySaved = await Axios.post(url, productCategory);
      return productCategorySaved.data;
    } catch (error) {
      throw error.response.data;
    }
  } // save()

  static async update(productCategory) {
    try {
      let productCategoryUpdated = await Axios.put(url, productCategory);
      return productCategoryUpdated.data;
    } catch (error) {
      throw error.response.data;
    }
  } // update()

  static async remove(productCategory) {
    try {
      await Axios.delete(url, {
        data: productCategory
      });
    } catch (error) {
      throw error.response.data;
    }
  } // remove()
} // class



// WEBPACK FOOTER //
// ./src/service/ProductCategoryService.js